import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

import "./main.scss";
import Main from "./main";

function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
